/**
 * Навигация по буквам в каталоге брендов.
 *
 * Клик по [data-letter-nav="A"] → плавный scroll к [data-letter-target="A"].
 * Оффсет учитывает sticky-хедер (desktop 260, mobile 180).
 */

function getNavOffset() {
    return window.innerWidth <= 750 ? 180 : 260;
}

function scrollToLetter(letter) {
    const target = document.querySelector(`[data-letter-target="${letter}"]`);
    if (!target) return;

    const offset = getNavOffset();
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
}

function init() {
    document.addEventListener('click', e => {
        const nav = e.target.closest('[data-letter-nav]');
        if (!nav) return;
        scrollToLetter(nav.getAttribute('data-letter-nav'));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
